$(document).ready( function () {

	$('#qualifications_table').tablesorter({
			debug: false,
			dateFormat: "ddmmyyyy",
			headers: {
				0 : { sorter: false },
				3 : { sorter: "shortDate"},
				4 : { sorter: "shortDate"},
			}
	});

	$('#club_members_table').tablesorter({
			debug: false,
			dateFormat: "ddmmyyyy",
			headers: {
				0 : { sorter: false },
				3 : { sorter: "shortDate"},
			}
	});

	$('#results_table').tablesorter({
			debug: false,
			dateFormat: "ddmmyyyy",
			headers: {
				3 : { sorter: "shortDate"},
			}
	});

	$('#invoice_table').tablesorter({
			debug: false,
			dateFormat: "ddmmyyyy",
			headers: {
				0 : { sorter : false },
				1 : { sorter : "digit"},
				2 : { sorter : "shortDate"},
				5 : { sorter : "digit"},
				6 : { sorter : "digit"}
			}
	});

	$('#payments_table').tablesorter({
			debug: false,
			dateFormat: "ddmmyyyy",
			headers: {
				0 : { sorter : false },
				1 : { sorter : "shortDate"},
				6 : { sorter : "digit"},
				7 : { sorter : "digit"},
				8 : { sorter : "digit"}
			}
	});
	$('#meet_entries_table').tablesorter({
			debug: "false",
			dateFormat: "uk"
	});
	$('.datepicker').datepicker({
			format: 'dd/mm/yyyy',
			autoclose: true,
			assumeNearbyYear: true,
			orientation: "bottom",
			todayBtn: "linked",
			todayHighlight: true,
			weekStart: 1
	});

	// $('.datepicker').datetimepicker({
	// 	format: 'DD/MM/YYYY'
	// });


    $('.clickable-row').click(function() {
        var href = $(this).data("href");
        if(href) {
            window.location = href;
        }
    });

	$(".chosen-select").select2({
	    theme: "bootstrap"
		});

	// $(".chosen-select").chosen({disable_search_threshold: 10});

	$(function () {
		$('[data-toggle="tooltip"]').tooltip()
	})
	$('.select-on-enter').click(function() {
		$(this).select();
	});

	// Apply  a "confirm" class to a button to prompt for confirmation before submitting
	$(".confirm").click(function(){
		if (!confirm("Are you sure?")){
			return false;
		}
	});

	 // Prevent form double-submissions
	$('form').submit(function(){
		$('input[type=submit]', this).attr('disabled', 'disabled');
	});

	// Apply a "checkbox-container" class to an element that contains a checkbox to allow clicking anywhere (e.g. in a <td> tag)
	$(function(){
		$('.checkbox-container').click(function (event) {
		  if (!$(event.target).is('input')) {
		     
		      $('input:checkbox', this).prop('checked', function (i, value) {
		         return !value;
		       });
		      // Fire the "change" event on the checkbox
		      $('input:checkbox', this).change();
		    }
		});
	});

	$(function () {
	  $('[data-toggle="popover"]').popover()
	})

	tinymce.init({
		selector: '.email-signature-editor',
		toolbar: "bold underline italic | undo redo | fontselect fontsizeselect forecolor backcolor removeformat | cut copy paste pastetext | hr | image link unlink",
		plugins: "image imagetools lists link paste textcolor",
		menubar: false,
		branding: false,
		automatic_uploads: true,
		images_upload_handler: function (blobInfo, success, failure) {
			if (blobInfo.base64().length > 32000) {
				failure('Image is too large for an email signature');
				return;
			}

			success("data:" + blobInfo.blob().type + ";base64," + blobInfo.base64());
		},
		mobile: {
			theme: 'modern',
			toolbar: "bold underline italic | bullist numlist,| cut copy paste | undo redo",
			plugins: "lists autolink paste",
			menubar: false
		}
	});
	

	tinymce.init({
		selector: '.html-editor',
		relative_urls : false,
		remove_script_host : false,
		toolbar: "bold underline italic | undo redo | alignleft aligncenter alignright alignjustify | fontselect fontsizeselect forecolor backcolor removeformat | cut copy paste pastetext | bullist numlist indent outdent  hr | table | link unlink",
		plugins: "table lists link paste textcolor",
		style_formats: [

			{title: '12px', inline: 'span', styles: {'font-size':'12pt','font-weight':'bold'}},

			{title: '24px', inline: 'span', styles: {'font-size': '24pt',color: 'red'}},

			{title: '36px', inline: 'span', styles: {'font-size': '36pt'}}

		],
		menubar: false,
		branding: false,
		automatic_uploads: true,
		images_upload_handler: function (blobInfo, success, failure) {
			if (blobInfo.base64().length > 32000) {
				failure('Image is too large for an email signature');
				return;
			}

			success("data:" + blobInfo.blob().type + ";base64," + blobInfo.base64());
		},
		mobile: {
			theme: 'modern',
			toolbar: "bold underline italic | bullist numlist,| cut copy paste | undo redo",
			plugins: "lists autolink paste",
			menubar: false
		}
	});
	


	// $(".html-editor").froalaEditor({
	// });
	// $(".html-editor").ckeditor
	// (
	//     {
	//         customConfig: "/js/ckeditor_config.js"
	//     }
	// );

	$(document).delegate('.tabbable-textarea', 'keydown', function(e) {
		var keyCode = e.keyCode || e.which;

		if (keyCode == 9) {
			e.preventDefault();
			var start = this.selectionStart;
			var end = this.selectionEnd;

			// set textarea value to: text before caret + tab + text after caret
			$(this).val($(this).val().substring(0, start)
				+ "    "
				+ $(this).val().substring(end));

			// put caret at right position again
			this.selectionStart =
			this.selectionEnd = start + 4;
		}
	});

	// Javascript to enable link to tab
	var pageNavExists = document.getElementById("pageNav");
	if (pageNavExists) {
		var url = document.location.toString();
		if (url.match('#')) {
			$('#pageNav a[href="#' + url.split('#')[1] + '"]').tab('show');
		}
		else {
			$('#pageNav a:first').tab('show')
		}

		// Change hash for page-reload
		$('#pageNav a').on('shown.bs.tab', function (e) {
			window.location.hash = e.target.hash;
		})
	}



});